<template>
  <div class="custom-filter-navigation"
       :class="filterNavigationStyles">
    <div class="back" @click="openFiltersList">
      {{ $t("customContentFilter.backToFiltersList") }}
    </div>

    <div class="btn-group">
      <base-button v-if="mode === 'create'"
                   class="create-button"
                   color="primary"
                   :loading="createLoading"
                   @click="$emit('create')">
        {{ $t("customContentFilter.createFilter") }}
      </base-button>

      <base-button v-else
                   class="update-button"
                   color="primary"
                   :loading="updateLoading"
                   @click="$emit('update')">
        {{ $t("customContentFilter.updateFilter") }}
      </base-button>

      <base-button v-if="mode === 'update'"
                   class="delete-button"
                   color="secondary"
                   :loading="removeLoading"
                   @click="$emit('remove')">
        {{ $t("customContentFilter.removeFilter") }}
      </base-button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: 'create'
      },

      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      createLoading: {
        type: Boolean,
        required: false,
        default: false
      },

      updateLoading: {
        type: Boolean,
        required: false,
        default: false
      },

      removeLoading: {
        type: Boolean,
        required: false,
        default: false
      },

      inputFocused: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    methods: {
      openFiltersList() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.customFilters',
            params: {
              modeId: this.modeId,
              childId: this.childId
            }
          })

          return
        }

        this.showModal('customFilters', {
          modeId: this.modeId,
          childId: this.childId
        })
      }
    },

    computed: {
      filterNavigationStyles() {
        return {
          'custom-filter-navigation-mobile-update': this.$mq === 'mobile' && this.mode === 'update',
          'custom-filter-navigation-hide': this.inputFocused
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-filter-navigation {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .back {
      font-size: 20px;
      cursor: pointer;
      user-select: none;
      text-decoration: underline;
      color: map.get($colors, primary);
    }

    .btn-group {
      display: flex;
      justify-content: center;
      align-items: center;

      .delete-button {
        margin-left: 10px;
      }
    }
  }

  .custom-filter-navigation-mobile-update {
    display: block;

    .back {
      margin: 10px 0 10px 0;
      text-align: center;
    }
  }

  .custom-filter-navigation-hide {
    display: none;
  }
</style>